import { lazy } from 'react'

export const SuspiciousActivityVariant1 = lazy(
  () => import('./SuspiciousActivityVariant1'),
)
